<template>
    <div
        v-if="
            state.currentView == 'GOOGLEPAY_INIT_VIEW' && state.processing != true
        "
    >
        <h5
            class="container__col-md-12 container__col-sm-12 payment__instruction"
        >
            {{ $t("googlepay.init.description") }}
        </h5>
        <PrimaryButton current-method="googlepay" :content="$t('googlepay.pay.btn')" @click="Next" />

    </div>
    <div
        v-else-if="
            state.currentView == 'REDIRECT_VIEW' && state.processing != true
        "
    >
        <div class="redirect-wrapper">
            <svg width="98" height="52" viewBox="0 0 98 52" fill="none" xmlns="http://www.w3.org/2000/svg" class="redirect-icon--google-pay">
                <path d="M71.3141 0.543213H26.2421C12.1571 0.543213 0.633057 12.0673 0.633057 26.1523C0.633057 40.2373 12.1571 51.7614 26.2421 51.7614H71.3141C85.3991 51.7614 96.9232 40.2373 96.9232 26.1523C96.9232 12.0673 85.3991 0.543213 71.3141 0.543213Z" fill="white"/>
                <path d="M71.3141 2.61755C74.4768 2.61755 77.5499 3.24497 80.4437 4.47421C83.2479 5.66503 85.7576 7.36803 87.9344 9.532C90.0984 11.696 91.8014 14.2185 92.9922 17.0227C94.2214 19.9165 94.8488 22.9896 94.8488 26.1523C94.8488 29.315 94.2214 32.3881 92.9922 35.2819C91.8014 38.0861 90.0984 40.5958 87.9344 42.7726C85.7704 44.9365 83.2479 46.6395 80.4437 47.8304C77.5499 49.0596 74.4768 49.687 71.3141 49.687H26.2421C23.0794 49.687 20.0063 49.0596 17.1125 47.8304C14.3083 46.6395 11.7986 44.9365 9.62184 42.7726C7.45787 40.6086 5.75487 38.0861 4.56405 35.2819C3.33481 32.3881 2.70739 29.315 2.70739 26.1523C2.70739 22.9896 3.33481 19.9165 4.56405 17.0227C5.75487 14.2185 7.45787 11.7088 9.62184 9.532C11.7858 7.36803 14.3083 5.66503 17.1125 4.47421C20.0063 3.24497 23.0794 2.61755 26.2421 2.61755H71.3141ZM71.3141 0.543213H26.2421C12.1571 0.543213 0.633057 12.0673 0.633057 26.1523C0.633057 40.2373 12.1571 51.7614 26.2421 51.7614H71.3141C85.3991 51.7614 96.9232 40.2373 96.9232 26.1523C96.9232 12.0673 85.3991 0.543213 71.3141 0.543213Z" fill="#3C4043"/>
                <path d="M46.5498 27.9705V35.7173H44.0913V16.5873H50.6088C52.2606 16.5873 53.6691 17.1379 54.8215 18.2391C55.9995 19.3403 56.5885 20.6847 56.5885 22.2725C56.5885 23.8987 55.9995 25.2431 54.8215 26.3315C53.6819 27.4199 52.2734 27.9577 50.6088 27.9577H46.5498V27.9705ZM46.5498 18.9433V25.6145H50.66C51.6332 25.6145 52.4527 25.2816 53.0929 24.6285C53.7459 23.9755 54.0788 23.1816 54.0788 22.2853C54.0788 21.4018 53.7459 20.6207 53.0929 19.9677C52.4527 19.289 51.646 18.9561 50.66 18.9561H46.5498V18.9433Z" fill="#3C4043"/>
                <path d="M63.0165 22.1958C64.8347 22.1958 66.2688 22.6824 67.3188 23.6555C68.3688 24.6287 68.8938 25.9603 68.8938 27.6505V35.7174H66.5505V33.8991H66.4481C65.4365 35.3973 64.0793 36.1399 62.3891 36.1399C60.9422 36.1399 59.7385 35.7174 58.7654 34.8595C57.7922 34.0016 57.3057 32.9388 57.3057 31.6584C57.3057 30.3011 57.8178 29.2255 58.8422 28.4316C59.8666 27.6249 61.2367 27.228 62.9397 27.228C64.3994 27.228 65.603 27.4969 66.5377 28.0347V27.4713C66.5377 26.6134 66.2048 25.8963 65.5262 25.2945C64.8475 24.6927 64.0537 24.3982 63.1445 24.3982C61.7745 24.3982 60.6861 24.9744 59.8922 26.1396L57.7282 24.7823C58.919 23.0537 60.6861 22.1958 63.0165 22.1958ZM59.841 31.6968C59.841 32.337 60.1099 32.8748 60.6605 33.2973C61.1982 33.7199 61.8385 33.9376 62.5683 33.9376C63.6055 33.9376 64.5274 33.5534 65.3341 32.7852C66.1408 32.0169 66.5505 31.1206 66.5505 30.0834C65.7823 29.4816 64.7195 29.1743 63.3494 29.1743C62.3507 29.1743 61.5184 29.4176 60.8525 29.8913C60.1739 30.3907 59.841 30.9925 59.841 31.6968Z" fill="#3C4043"/>
                <path d="M82.2618 22.6182L74.0669 41.4665H71.5316L74.5791 34.8722L69.1755 22.6182H71.8517L75.7443 32.0168H75.7955L79.5856 22.6182H82.2618Z" fill="#3C4043"/>
                <path d="M36.7712 26.4083C36.7712 25.6068 36.6995 24.8398 36.5663 24.1022H26.2612V28.3277L32.1961 28.329C31.9554 29.735 31.1807 30.9335 29.9938 31.7325V34.4739H33.5265C35.5893 32.5648 36.7712 29.7426 36.7712 26.4083Z" fill="#4285F4"/>
                <path d="M29.9951 31.7326C29.0117 32.3959 27.7453 32.7839 26.2638 32.7839C23.402 32.7839 20.9743 30.8555 20.1049 28.2562H16.4607V31.0834C18.2661 34.6661 21.9769 37.1246 26.2638 37.1246C29.2268 37.1246 31.716 36.1502 33.5279 34.4728L29.9951 31.7326Z" fill="#34A853"/>
                <path d="M19.7617 26.1587C19.7617 25.4288 19.8833 24.7233 20.1049 24.06V21.2328H16.4607C15.7142 22.7143 15.2942 24.3865 15.2942 26.1587C15.2942 27.9308 15.7155 29.6031 16.4607 31.0846L20.1049 28.2574C19.8833 27.5941 19.7617 26.8886 19.7617 26.1587Z" fill="#FABB05"/>
                <path d="M26.2638 19.5324C27.8811 19.5324 29.3293 20.0894 30.4727 21.1778L33.6034 18.0496C31.7019 16.2788 29.223 15.1917 26.2638 15.1917C21.9782 15.1917 18.2661 17.6501 16.4607 21.2328L20.1049 24.0601C20.9743 21.4608 23.402 19.5324 26.2638 19.5324Z" fill="#E94235"/>
            </svg>
        </div>
        <p class="container__col-md-12 container__col-sm-12 payment__instruction--google-pay">
            {{ $t("googlepay.redirect.description")}}
        </p>
        <PrimaryButton current-method="googlepay" :content="$t('googlepay.redirect.btn')" @click="Next" />
    </div>
</template>

<script>
import { ref, onBeforeUnmount } from "vue";
import { injectStore, mapState } from "redux-vuex";

import { getValueFromPath, autoInitialize } from "@/support/helpers";
import PrimaryButton from "@/components/form/base-button";
import { onUpdated } from "@vue/runtime-core";

export default {
    name: "Googlepay",
    components: {
        PrimaryButton,
    },

    setup() {
        const store = injectStore();
        const checkoutData = ref(store.getState());

        function Next() {
            setTimeout(() => {
                checkoutData.value.view.context.$actions.next();
            }, 0);
        }

        const subscription = store.subscribe(() => {
            checkoutData.value = store.getState();
        });

        const autoInitializePayment = autoInitialize("GOOGLEPAY_INIT_VIEW");

        onUpdated(() =>  autoInitializePayment(checkoutData, Next));

        onBeforeUnmount(() => {
            subscription();
        });

        return {
            state: mapState({
                processing: (state) => getValueFromPath(state, "processing") || false,
                currentView: (state) => getValueFromPath(state, "view.current") || null,
            }),
            getValueFromPath,
            Next,
        };

    },

};
</script>

<style>

</style>